<template>
  <div v-if="messages.length" class="br-scan-alert">
    <p v-for="(message, index) in messages" :key="index" class="br-scan-alert__text">
      {{ message }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'BrScanAlert',
  props: {
    alertKeys: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    messages() {
      const keyToLabel = {
        not_license: 'lbl_EMPBE_BR_Alert_NotLicense',
        extract_failed: 'lbl_EMPBE_BR_Alert_ExtractFailed',
        scan_failed: 'lbl_EMPBE_BR_Alert_ScanFailed',
        endpoint_not_found: 'lbl_EMPBE_BR_Alert_EndpointNotFound',
        file_size: 'lbl_EMPBE_BR_Upload_SizeError',
        file_type: 'lbl_EMPBE_BR_Upload_TypeError',
      };
      return (this.alertKeys || [])
        .map((key) => keyToLabel[key])
        .filter(Boolean)
        .map((labelKey) => this.$t(labelKey));
    },
  },
};
</script>
